import script from "./TraitRanksOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitRanksOffers.vue?vue&type=script&setup=true&lang=js"

import "./TraitRanksOffers.vue?vue&type=style&index=0&id=12d62d2f&lang=scss"

const __exports__ = script;

export default __exports__